import { Component, Injector, OnInit } from '@angular/core';
import { DialogBaseComponent } from "../../../admin-panel/base-admin-panel/dialog-base/dialog-base.component";
declare var g_Controls: any;

@Component({
    selector: 'app-command-dialog',
    templateUrl: './c.component.html',
    styleUrls: ['./c.component.css'],
    standalone: false
})
export class CommandDialogComponent  extends DialogBaseComponent<any> implements OnInit {
  constructor(protected injector: Injector) {
    super(injector);
  }
  ngOnInit() {
    super.ngOnInit();
  }
  public submit() {
    if (g_Controls["commandcontrol"].Apply())
      super.submit();
  }
}
